var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "7787548_wrong_delete_remove_trash_minus_icon"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 91678",
    d: "M33.5 15a18.485 18.485 0 1 0 13.086 5.414A18.5 18.5 0 0 0 33.5 15zm0 32.647a14.119 14.119 0 1 1 10.012-4.135A14.147 14.147 0 0 1 33.5 47.647z",
    transform: "translate(-15 -15)",
    style: {
      fill: "#ed344e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 91679",
    d: "M82.028 71.654a2.1 2.1 0 0 0-3.047 0l-3.156 3.156-3.047-3.047a2.155 2.155 0 1 0-3.047 3.047l3.047 3.047-3.047 3.043a2.155 2.155 0 1 0 3.047 3.047l3.047-3.047 3.047 3.047A2.155 2.155 0 1 0 81.92 80.9l-3.047-3.047 3.047-3.047a2.344 2.344 0 0 0 .108-3.152z",
    transform: "translate(-57.325 -58.813)",
    style: {
      fill: "#ed344e"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.svg";
export { ForwardRef as ReactComponent };